export const SIDEBAR_WIDTH = '88px';
export const SIDEBAR_EXPANDED_WIDTH = '250px';
